import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { catchError, take, tap } from 'rxjs/operators';
import { Country } from 'src/app/models/country.model';
import { SelectItemModel } from 'src/app/models/select-item';
import { QuoteService } from 'src/app/service/quote.service';
import { BooleanOptionalBenefitRate, CardPaymentRequestModel, DecimalOptionalBenefitRate, GetQuoteResponseModel, SendQuoteByEmailModel } from 'src/app/service/web-api-client';
import { ErrorModalComponent, ErrorModalData } from '../../quote-step3/error-modal.component';

@Component({
  selector: 'app-quote-step7-desktop',
  templateUrl: './quote-step7-desktop.component.html',
  styleUrls: ['./quote-step7-desktop.component.css']
})
export class QuoteStep7DesktopComponent implements OnInit {
  @Input()
  vectorsrc32: string = '/assets/external/vectori3211-m0v.svg'
  @Input()
  ellipse25src1: string = '/assets/external/ellipse253387-wqbc.svg'
  @Input()
  vectorsrc27: string = '/assets/external/vectori3211-0iwu.svg'
  @Input()
  vectoralt14: string = 'VectorI3387'
  @Input()
  paymentMethodVisasrc: string =
    '/assets/external/paymentmethodvisa3387-tab.svg'
  @Input()
  vectoralt11: string = 'VectorI3387'
  @Input()
  vectorsrc14: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/6fb227c0-ebb6-46d8-8aa7-c54ee8b17974?org_if_sml=1740&force_format=original'
  @Input()
  vectorsrc5: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/cb15573a-bd3d-4294-b817-d9c3844de7f1?org_if_sml=11330&force_format=original'
  @Input()
  vectoralt9: string = 'VectorI3387'
  @Input()
  vectorsrc4: string = '/assets/external/vector3387-pcgw.svg'
  @Input()
  vectorsrc18: string = '/assets/external/Mask group.svg'
  @Input()
  vectorsrc34: string = '/assets/external/vectori3211-su9.svg'
  @Input()
  vectorsrc3: string = '/assets/external/vector3387-ppdc.svg'
  @Input()
  ellipse25alt1: string = 'Ellipse253387'
  @Input()
  inputplaceholder1: string = '';
  @Input()
  vectorsrc21: string = '/assets/external/Mask group.svg'
  @Input()
  vectoralt1: string = 'Vector3387'
  @Input()
  ellipse25alt2: string = 'Ellipse253387'
  @Input()
  vectoralt4: string = 'Vector3387'
  @Input()
  vectorsrc9: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/b7868c62-b058-4ff2-abfd-65ee06a5c025?org_if_sml=1633&force_format=original'
  @Input()
  vectoralt29: string = 'VectorI3211'
  @Input()
  vectorsrc2: string = '/assets/external/vector3387-ix4p.svg'
  @Input()
  vectorsrc13: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/a67eef8f-ae81-4c55-b71d-db90d724a382?org_if_sml=1222&force_format=original'
  @Input()
  ellipse25src3: string = '/assets/external/ellipse253387-h42r.svg'
  @Input()
  vectorsrc28: string = '/assets/external/vectori3211-t2cq.svg'
  @Input()
  vectorsrc15: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/711e8483-713c-4808-8304-d4dd48adff28?org_if_sml=1490&force_format=original'
  @Input()
  vectorsrc6: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/429073ec-f0d7-49c0-93e4-09c7808bfa0b?org_if_sml=1624&force_format=original'
  @Input()
  vectorsrc: string = '/assets/external/vector3387-jtb9.svg'
  @Input()
  vectoralt32: string = 'VectorI3211'
  @Input()
  inputplaceholder3: string = 'MM/YY'
  @Input()
  vectorsrc10: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/c86c08c9-3ecd-4718-8693-a2ad05aa0b3e?org_if_sml=1521&force_format=original'
  @Input()
  vectorsrc1: string = '/assets/external/vector3387-3b3.svg'
  @Input()
  vectorsrc22: string = '/assets/external/Mask group.svg'
  @Input()
  vectorsrc24: string = '/assets/external/vectori3211-cr9.svg'
  @Input()
  vectorsrc26: string = '/assets/external/vectori3211-o5qi.svg'
  @Input()
  line34alt: string = 'Line34I3211'
  @Input()
  vectoralt23: string = 'VectorI3211'
  @Input()
  paymentMethodMastercardalt: string = 'PaymentMethodMastercard3387'
  @Input()
  line34src: string = '/assets/external/line34i3211-wjit.svg'
  @Input()
  ellipse25alt: string = 'Ellipse253387'
  @Input()
  ellipse25src2: string = '/assets/external/ellipse253387-vevr.svg'
  @Input()
  vectoralt25: string = 'VectorI3211'
  @Input()
  vectoralt13: string = 'VectorI3387'
  @Input()
  vectoralt20: string = 'VectorI3211'
  @Input()
  vectoralt33: string = 'VectorI3211'
  @Input()
  vectoralt16: string = 'VectorI3211'
  @Input()
  vectorsrc20: string = '/assets/external/Mask group.svg'
  @Input()
  vectoralt36: string = 'VectorI3211'
  @Input()
  vectoralt15: string = 'VectorI3387'
  @Input()
  vectoralt17: string = 'VectorI3211'
  @Input()
  paymentMethodApplePaysrc: string =
    '/assets/external/paymentmethodapplepay3387-ydio.svg'
  @Input()
  vectoralt2: string = 'Vector3387'
  @Input()
  paymentMethodApplePayalt: string = 'PaymentMethodApplePay3387'
  @Input()
  vectorsrc29: string = '/assets/external/vectori3211-mb35.svg'
  @Input()
  vectorsrc17: string = '/assets/external/Mask group.svg'
  @Input()
  vectoralt6: string = 'VectorI3387'
  @Input()
  vectoralt3: string = 'Vector3387'
  @Input()
  vectoralt5: string = 'VectorI3387'
  @Input()
  vectoralt30: string = 'VectorI3211'
  @Input()
  vectoralt: string = 'Vector3387'
  @Input()
  vectorsrc11: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/729d6647-8d1a-41fa-9827-e61b43881c19?org_if_sml=1743&force_format=original'
  @Input()
  inputplaceholder: string = 'Andrea'
  @Input()
  vectoralt8: string = 'VectorI3387'
  @Input()
  vectoralt35: string = 'VectorI3211'
  @Input()
  vectorsrc12: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/8cbd8445-aa1a-4b8d-82f2-277ffc75a4d8?org_if_sml=1743&force_format=original'
  @Input()
  vectoralt22: string = 'VectorI3211'
  @Input()
  ellipse25alt3: string = 'Ellipse253387'
  @Input()
  rootClassName: string = ''
  @Input()
  vectorsrc7: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/f4ee6fb0-3bd4-4370-97dd-2cc7bd0209d5?org_if_sml=1171&force_format=original'
  @Input()
  vectoralt10: string = 'VectorI3387'
  @Input()
  vectoralt7: string = 'VectorI3387'
  @Input()
  vectoralt19: string = 'VectorI3211'
  @Input()
  vectoralt28: string = 'VectorI3211'
  @Input()
  vectorsrc30: string = '/assets/external/vectori3211-i49p.svg'
  @Input()
  ellipse25src4: string = '/assets/external/ellipse253387-kgvj.svg'
  @Input()
  vectoralt31: string = 'VectorI3211'
  @Input()
  vectorsrc36: string = '/assets/external/vectori3211-2096.svg'
  @Input()
  vectoralt12: string = 'VectorI3387'
  @Input()
  vectorsrc35: string = '/assets/external/vectori3211-pkkf.svg'
  @Input()
  vectorsrc23: string = '/assets/external/vectori3211-r099.svg'
  @Input()
  vectorsrc33: string = '/assets/external/vectori3211-y4z.svg'
  @Input()
  ellipse25alt4: string = 'Ellipse253387'
  @Input()
  vectoralt24: string = 'VectorI3211'
  @Input()
  paymentMethodMastercardsrc: string =
    '/assets/external/paymentmethodmastercard3387-phod.svg'
  @Input()
  ellipse25src: string = '/assets/external/ellipse253387-yiyj.svg'
  @Input()
  vectorsrc31: string = '/assets/external/vectori3211-070a.svg'
  @Input()
  vectoralt27: string = 'VectorI3211'
  @Input()
  inputplaceholder2: string = ''
  @Input()
  vectoralt34: string = 'VectorI3211'
  @Input()
  vectorsrc19: string = '/assets/external/Mask group.svg'
  @Input()
  vectoralt18: string = 'VectorI3211'
  @Input()
  vectoralt21: string = 'VectorI3211'
  @Input()
  vectoralt26: string = 'VectorI3211'
  @Input()
  vectorsrc8: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/a0bf31ba-56e9-4340-82b5-81e0ccc5c47c?org_if_sml=1502&force_format=original'
  @Input()
  paymentMethodVisaalt: string = 'PaymentMethodVisa3387'
  @Input()
  vectorsrc16: string = '/assets/external/Mask group.svg'
  @Input()
  vectorsrc25: string = '/assets/external/vectori3211-kv15.svg'
  rawx7mt: string = ' ';
  rawlxt6: string = ' ';
  rawgfae: string = ' ';
  rawk0hw: string = ' ';
  raw5csv: string = ' ';

  heartalt: string = 'HeartI3346'
  vectorUnFilled: string = '/assets/external/vector3387-ovts.svg'
  vectorfilled: string = '/assets/external/vector3387-ynbm.svg'

  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();

  selectedCoverage: any = null;
  selectedCancelTravel: any = null;
  selectedPracticesSport: any = null;
  selectedMedicalCondition: any = null;
  selectedFutureMom: any = null;
  selectedAssistPet: any = null;
  selectedLegalAssist: any = null;

  priceValue: number = 0;
  // durationInDays: number = 0;
  personCount: number = 1;
  geographicalDestination: string = '';
  istrumsAcsspted: boolean = false
  termsAlert: boolean = false
  planId = 0;


  readonly maximumCoverage: any[] = [
    { name: '$ 250,000', key: '250000', planName: 'Superior' },    
    { name: '$ 100,000', key: '100000', planName: 'Standard' },
    { name: '$ 50,000', key: '50000', planName: 'Light' },
  ];
  readonly cancelTravel: any[] = [
    { name: '$ 0', key: '0' },
    { name: '$ 2,500', key: '2500' }
  ];
  readonly practicesSport: any[] = [
    { name: 'No', key: '0' },
    { name: 'Sí', key: '1' }
  ];
  readonly medicalCondition: any[] = [
    { name: 'No', key: '0' },
    { name: 'Sí', key: '1' }
  ];
  readonly futureMom: any[] = [
    { name: 'No', key: '0' },
    { name: 'Sí', key: '1' }
  ];
  readonly assistPet: any[] = [
    { name: 'No', key: '0' },
    { name: '1', key: '1' },
    { name: '2', key: '2' },
    { name: '3', key: '3' }
  ];
  readonly legalAssist: any[] = [
    { name: 'No', key: '0' },
    { name: 'Sí', key: '1' }
  ];

  loading: boolean = false;

  maxCoverageRate: number = 0;
  cancellationDueToCatastrophicTripRate: number = 0;
  sportPracticeRate: number = 0;
  preexistingMedicalConditionsRate: number = 0;
  petsRate: number = 0;
  futureMomRate: number = 0;
  legalVIPAssistanceRate: number = 0;
  countries: Country[] = [];

  stepThreeForm: FormGroup;
  stepSevenForm: FormGroup;
  sendQuoteByEmailForm: FormGroup;
  emailSendingStatus: number = 0;
  private _isBusy: boolean = false;
  isBusy: boolean = false;
  submitted: boolean = false;

  paymentStatus: number = 0;
  paymentAuthNumber: string = null;
  isSectionVisible: boolean = false; // Initially hidden
  paymentErrorMessage: string = '';
  currentErrorData: ErrorModalData | null = null;

  days: SelectItemModel[] = Array.from({ length: 30 }, (_, i) => ({ id: i + 1, text: (i + 1).toString() }));
  months: SelectItemModel[] = [
    { id: 1, text: 'Enero' },
    { id: 2, text: 'Febrero' },
    { id: 3, text: 'Marzo' },
    { id: 4, text: 'Abril' },
    { id: 5, text: 'Mayo' },
    { id: 6, text: 'Junio' },
    { id: 7, text: 'Julio' },
    { id: 8, text: 'Agosto' },
    { id: 9, text: 'Septiembre' },
    { id: 10, text: 'Octubre' },
    { id: 11, text: 'Noviembre' },
    { id: 12, text: 'Diciembre' },
  ]
  years: SelectItemModel[] = Array.from({ length: 10 }, (_, i) => {
    const year = new Date().getFullYear() + i;
    return { id: year, text: year.toString() };
  });

  filteredMonths: SelectItemModel[] = [];


  constructor(
    public quoteService: QuoteService,
    private fb: FormBuilder,
    private http: HttpClient) {
    this.createForm();
  }

  createForm() {
    this.sendQuoteByEmailForm = this.fb.group({
      optionalRecipients: ['']
    });

    this.stepSevenForm = this.fb.group({
      cardHolderName: [null, [Validators.required, Validators.minLength(2)]],
      cardNumber: [null, [Validators.required, Validators.minLength(16),Validators.maxLength(16),Validators.pattern(/^[0-9]*$/)]],
      cardExpirationMonth: [null, Validators.required],
      cardExpirationYear: [new Date().getFullYear(), Validators.required],
      cardCvv: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(3), Validators.pattern(/^[0-9]*$/)]],
      cardExpirationDay: [1, Validators.required],
      countrie: [null, Validators.required],
    });

    this.http.get<Country[]>('/assets/countrycode/CountryCodes.json').subscribe(data => {
      this.countries = data.map(country => {
        return {
          name: country.name,
          code: country.code,
          phoneCode: country.phoneCode,
          flag: country.flag,
          id: country.phoneCode,
          text: country.name
        };
      });
    });
    this.stepThreeForm = this.fb.group({
      applicantName: ['', Validators.required],
      applicantLastName: ['', Validators.required],
      applicantEmail: ['', Validators.required],
      phoneCode: ['', Validators.required],
      applicantPhone: ['', Validators.required],
      checkedMarketing: [false,  Validators.requiredTrue],
    });

    if (this.quoteService.quoteModel) {
      if (this.quoteService.quoteModel.members[0].firstName && this.quoteService.quoteModel.members[0].lastName &&
        this.quoteService.quoteModel.members[0].email) {
        this.stepThreeForm.controls.applicantName.setValue(this.quoteService.quoteModel.members[0].firstName)
        this.stepThreeForm.controls.applicantLastName.setValue(this.quoteService.quoteModel.members[0].lastName)
        this.stepThreeForm.controls.applicantEmail.setValue(this.quoteService.quoteModel.members[0].email)
        if (this.quoteService.quoteModel.members[0].phones.length > 0 && this.quoteService.quoteModel.members[0].phones[0].phoneNumber && this.quoteService.quoteModel.members[0].phones[0].countryCode) {
          this.stepThreeForm.controls.phoneCode.setValue(this.quoteService.quoteModel.members[0].phones[0].countryCode)
          this.stepThreeForm.controls.applicantPhone.setValue(this.quoteService.quoteModel.members[0].phones[0].phoneNumber)
        }
        if(this.quoteService.quoteModel.members[0].phones.length > 0 && !this.quoteService.quoteModel.members[0].phones[0].countryCode){
          this.stepThreeForm.controls.phoneCode.setValue('+34');
        }
      }
    }
  }


   updateFilteredMonths(selectedYear: number = new Date().getFullYear()) {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1; // JS months are 0-based
    
    if (selectedYear === currentYear) {
      // Filter out past months
      this.filteredMonths = this.months.filter(month => month.id >= currentMonth);
      const expMonth = this.stepSevenForm.controls.cardExpirationMonth.value;
      if(this.filteredMonths.filter(month => month.id == expMonth).length == 0){
        this.stepSevenForm.controls.cardExpirationMonth.setValue(null);
      }
    } else {
      // Show all months
      this.filteredMonths = [...this.months];
    }

  }

  get isPayButtonDisabled(): boolean {
    if (this.istrumsAcsspted == false) {
      return true
    }
    return (this.stepSevenForm.valid != true || this._isBusy == true || this.paymentStatus == 1 );
  }

  get isContinueButtonDisabled(): boolean {
    return this.paymentStatus != 1;
  }

  /** "10 nov – 20 nov 2026" a partir de las fechas yyyy-MM-dd del viaje (sin desfase horario) */
  get tripRangeLabel(): string {
    const parse = (v: any): Date | null => {
      if (!v) { return null; }
      const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v));
      if (m) { return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])); }
      const d = new Date(v);
      return isNaN(d.getTime()) ? null : d;
    };
    const a = parse(this.quoteService.quoteModel.tripStartDate);
    const b = parse(this.quoteService.quoteModel.tripEndDate);
    if (!a || !b) { return ''; }
    const M = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    const f = (d: Date, withYear: boolean) => d.getDate() + ' ' + M[d.getMonth()] + (withYear ? ' ' + d.getFullYear() : '');
    return f(a, a.getFullYear() !== b.getFullYear()) + ' – ' + f(b, true);
  }

  get durationInDays(): number {
    if (!this.quoteService.quoteModel.tripStartDate || !this.quoteService.quoteModel.tripEndDate) {
      return 0;
    }

    const startDate: Date = new Date(this.quoteService.quoteModel.tripStartDate);
    const endDate: Date = new Date(this.quoteService.quoteModel.tripEndDate);

    if (startDate >= endDate) {
      return 0;
    }

    var diff = Math.abs(endDate.getTime() - startDate.getTime());
    var diffDays = Math.ceil(diff / (1000 * 3600 * 24));

    return diffDays + 1;
  }


  toggleSection() {
    this.isSectionVisible = !this.isSectionVisible; // Toggle visibility
  }

  toggleTermsAndConditions() {
    this.stepThreeForm.controls.checkedMarketing.setValue(false);
    document.getElementById('openExampleModalCenter').click();
  }

  toggleAgreement($event: any) {
    const formValue = !!$event.target.checked;
    this.istrumsAcsspted = formValue;
    this.stepThreeForm.controls.checkedMarketing.setValue(formValue);
    if (formValue) {
      this.termsAlert = false;
    }
  }

  acceptFromModal($event: any) {
    this.toggleAgreement($event);
    if (this.istrumsAcsspted) {
      // el mismo boton que abre la ventana la cierra (toggle del modal)
      document.getElementById('openExampleModalCenter').click();
    }
  }

  private warnTerms(): void {
    this.termsAlert = false;
    setTimeout(() => {
      this.termsAlert = true;
      const box = document.getElementById('termsAcceptBox');
      if (box) {
        box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, 0);
  }

  nextStep(): void {
    if (this.paymentStatus != 1) {
      return;
    }

    this.onNextStep.emit(this.currentStep);
  }
  jumpTpStep(step: number): void {
    this.onNextStep.emit(step);
  }
  prevStep(): void {
    this.onPrevStep.emit(this.currentStep);
  }

  ngOnInit() {
    this.priceValue = this.quoteService.quoteModel.price;
    // this.durationInDays = this.quoteService.quoteModel.durationInDays;
    this.planId = this.quoteService.quoteModel.rateResponse.planId - 1 ;
    this.maxCoverageRate = this.quoteService.quoteRateModel.maxCoverage.rate ?? 0;
    this.cancellationDueToCatastrophicTripRate = this.quoteService.quoteRateModel.cancellationDueToCatastrophicTrip.rate ?? 0;
    this.sportPracticeRate = this.quoteService.quoteRateModel.sportPractice.rate ?? 0;
    this.preexistingMedicalConditionsRate = this.quoteService.quoteRateModel.preexistingMedicalConditions.rate ?? 0;
    this.petsRate = this.quoteService.quoteRateModel.pets.rate ?? 0;
    this.futureMomRate = this.quoteService.quoteRateModel.futureMom.rate ?? 0;
    this.legalVIPAssistanceRate = this.quoteService.quoteRateModel.legalVipAssistance.rate ?? 0;
    console.log(this.quoteService.quoteRateModel);
    this.selectedCoverage = this.maximumCoverage.find(i => i.key == this.quoteService.quoteRateModel.maxCoverage.value) ?? { name: '' };
    this.selectedCancelTravel = this.quoteService.quoteRateModel.cancellationDueToCatastrophicTrip.value as any == true ? this.cancelTravel[1] : this.cancelTravel[0];    
    console.log(this.selectedCancelTravel);
    this.selectedPracticesSport = this.practicesSport.find(i => i.key == (this.quoteService.quoteRateModel.sportPractice.value ? '1' : '0')) ?? { name: 'No' };
    this.selectedMedicalCondition = this.medicalCondition.find(i => i.key == (this.quoteService.quoteRateModel.preexistingMedicalConditions.value ? '1' : '0')) ?? { name: 'No' };
    this.selectedFutureMom = this.futureMom.find(i => i.key == (this.quoteService.quoteRateModel.futureMom.value ? '1' : '0')) ?? { name: 'No' };
    this.selectedAssistPet = this.assistPet.find(i => i.key == this.quoteService.quoteRateModel.pets.value) ?? { name: 'No' };
    this.selectedLegalAssist = this.legalAssist.find(i => i.key == (this.quoteService.quoteRateModel.legalVipAssistance.value ? '1' : '0')) ?? { name: 'No' };

    this.personCount = this.quoteService.quoteModel.dependentCount + this.quoteService.quoteModel.dependentCountOver65 + 1;

    this.geographicalDestination = this.quoteService.quoteModel.destinationRegion.name;
    this.updateFilteredMonths()
    // 👇 Subscribe to year changes
  this.stepSevenForm.get('cardExpirationYear').valueChanges.subscribe(selectedYear => {
    this.updateFilteredMonths(selectedYear);
  });
  }

  pay(): void {
    if (!this.istrumsAcsspted) {
      this.warnTerms();
      return;
    }
    this._isBusy = true;
    this.submitted = true;
    // if (this._isBusy) {
    //   return;
    // }
    if (this.stepSevenForm.valid && this.stepThreeForm.valid) {
      document.getElementById('sendpaymentModalToggle').click();

      this.loading = true;
      this._isBusy = true;
      
      this.paymentStatus = 0;
      this.paymentAuthNumber = null;
      const paymentRequest = new CardPaymentRequestModel({
        amount: 200,
        cardholderName: this.stepSevenForm.controls.cardHolderName.value,
        cardNumber: this.stepSevenForm.controls.cardNumber.value,
        cvv: this.stepSevenForm.controls.cardCvv.value,
        expirationMonth: parseInt(this.stepSevenForm.controls.cardExpirationMonth.value),
        expirationYear: parseInt(this.stepSevenForm.controls.cardExpirationYear.value),
        number: this.quoteService.quoteModel.number,
        payer: {
          email: this.stepThreeForm.controls.applicantEmail.value,
          firstName: this.stepThreeForm.controls.applicantName.value,
          lastName: this.stepThreeForm.controls.applicantLastName.value,
          phone: {
            countryCode: this.stepThreeForm.controls.phoneCode.value,
            phoneNumber: this.stepThreeForm.controls.applicantPhone.value,
            phoneTypeId: 1
          }
        },
        card: {
          cardholderName: this.stepSevenForm.controls.cardHolderName.value,
          cardNumber: this.stepSevenForm.controls.cardNumber.value,
          expirationMonth: parseInt(this.stepSevenForm.controls.cardExpirationMonth.value),
          expirationYear: parseInt(this.stepSevenForm.controls.cardExpirationYear.value),
          cvv: this.stepSevenForm.controls.cardCvv.value
        },
      });

      const self = this;
      // self.nextStep(); //Do not checkin
      this.quoteService.makeAPayment$(paymentRequest)
        .pipe(
          //take(1),
          tap(r => {
            self._isBusy = false;
            self.loading = false;
            if (r && r.isSuccess) {
              self.paymentStatus = 1;
              self.paymentAuthNumber = r.authorizationNumber;

              // Create pending activation certificate after successful payment
              if (!self.quoteService.quoteModel.number) {
                self.nextStep();
                document.getElementById('sendpaymentModalToggle').click();
                return;
              }
              self.quoteService.createPendingActivationCertificate$(self.quoteService.quoteModel.number)
                .subscribe(
                  certificateResult => {
                    self.nextStep();
                    document.getElementById('sendpaymentModalToggle').click();
                  },
                  certificateError => {
                    // Payment was successful, but certificate creation failed.
                    // Do NOT go to next step. Show error modal instead based on backend error code.
                    const errorCode = self.extractPaymentErrorCode(certificateError);
                    self.currentErrorData = self.createPaymentErrorModalData(errorCode);
                    document.getElementById('sendpaymentModalToggle').click();
                  }
                );
            }
            else {
              self.paymentStatus = 2;
              
              // Extract error code from different possible error response structures
              const errorCode = self.extractPaymentErrorCode(r);
              
              self.currentErrorData = self.createPaymentErrorModalData(errorCode);
              this.loading = false;
              document.getElementById('sendpaymentModalToggle').click();
            }
          })
        ).subscribe(success => {
        }, error => {
            console.log('Payment subscription error: ', error);
            this.loading = false;
          self.paymentStatus = 2;
          
          // Extract error code from different possible error response structures
          const errorCode = self.extractPaymentErrorCode(error);
          
          self.currentErrorData = self.createPaymentErrorModalData(errorCode);
          console.log('Payment error: ', error);
          document.getElementById('sendpaymentModalToggle').click();
        });
         
    }
  }
  get canContinue(): boolean {
    return this.sendQuoteByEmailForm.valid && this.validateEmail(this.sendQuoteByEmailForm.controls.optionalRecipients.value);
  }
  private validateEmail(email: string): boolean {
    let res = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return res.test(email);
  }

  private getPaymentErrorMessage(errorCode: string): string {
    switch (errorCode) {
      case 'ERR.PAYMENT.CARD.INVALID':
        return '👉 Los datos de la tarjeta no son válidos. Revisa la información e inténtalo de nuevo.\nSi el problema continúa, contáctanos en service@blueassist.biz';
      case 'ERR.PAYMENT.DECLINED.DUPLICATE':
        return '👉 Parece que este pago ya fue procesado. Intenta con uno nuevo.\nSi el problema continúa, contáctanos en service@blueassist.biz';
      case 'ERR.PAYMENT.DECLINED':
        return '👉 El pago fue rechazado. Intenta de nuevo o usa otro método.\nSi el problema continúa, contáctanos en service@blueassist.biz';
      case 'ERR.PAYMENT.DECLINED.BY.ISSUER':
        return '👉 El banco ha rechazado la operación. Contacta con tu entidad para más detalles.\nSi el problema continúa, contáctanos en service@blueassist.biz';
      case 'ERR.PAYMENT.DECLINED.INSUFFICIENT.FUNDS':
        return '👉 No tienes fondos suficientes para completar el pago.\nSi el problema continúa, contáctanos en service@blueassist.biz';
      case 'ERR.PAYMENT.DECLINED.FRAUD':
        return '👉 La tarjeta fue reportada por actividad sospechosa. Contacta con tu banco.\nSi el problema continúa, contáctanos en service@blueassist.biz';
      case 'ERR.PAYMENT.DECLINED.STOLEN.CARD':
        return '👉 La tarjeta fue reportada como robada. No es posible procesar el pago.\nSi el problema continúa, contáctanos en service@blueassist.biz';
      case 'ERR.VAL.INV':
        return 'Esta cotización ya ha sido pagada. No se puede procesar un pago duplicado.';
      default:
        return 'Ha ocurrido un error durante el procesamiento del pago. Por favor, intente nuevamente.';
    }
  }

  /**
   * Extracts a backend payment error code from various possible response shapes.
   * Supports legacy shapes and the new shape:
   * {
   *   title: string,
   *   status: number,
   *   Errors: [{ errorCode: string, errorMessage?: string }] // capital 'E'
   * }
   */
  private extractPaymentErrorCode(response: any): string {
    // Direct responseCode at root
    if (response?.responseCode) {
      return response.responseCode;
    }
    // Angular HttpErrorResponse shape
    if (response?.error?.responseCode) {
      return response.error.responseCode;
    }
    // SwaggerException shape: parse response string if present
    const swaggerText = typeof response?.response === 'string' ? response.response : null;
    if (swaggerText) {
      try {
        const parsed = JSON.parse(swaggerText);
        const codeFromParsed = this.extractPaymentErrorCode(parsed);
        if (codeFromParsed) {
          return codeFromParsed;
        }
      } catch { /* ignore JSON parse errors */ }
    }
    // SwaggerException with parsed result (if API client passed it via throwException)
    if (response?.result) {
      const codeFromResult = this.extractPaymentErrorCode(response.result);
      if (codeFromResult) {
        return codeFromResult;
      }
    }
    // New backend shape: capital 'Errors' array at root
    const rootErrors = response?.Errors;
    if (Array.isArray(rootErrors) && rootErrors.length > 0 && rootErrors[0]?.errorCode) {
      return rootErrors[0].errorCode;
    }
    // Validation errors at root-level 'errors' object (per RFC 9110 validation problem details)
    const rootValidationErrorsObj = response?.errors;
    if (rootValidationErrorsObj && typeof rootValidationErrorsObj === 'object') {
      const errorKeys = Object.keys(rootValidationErrorsObj);
      if (errorKeys.length > 0) {
        return errorKeys[0];
      }
    }
    // New backend shape inside error.error
    const nestedErrors = response?.error?.Errors;
    if (Array.isArray(nestedErrors) && nestedErrors.length > 0 && nestedErrors[0]?.errorCode) {
      return nestedErrors[0].errorCode;
    }
    // Validation errors as object map
    const validationErrors = response?.error?.errors;
    if (validationErrors && typeof validationErrors === 'object') {
      const keys = Object.keys(validationErrors);
      if (keys.length > 0) {
        return keys[0];
      }
    }
    // As a last resort, map any 5xx to generic
    const statusCode = response?.status ?? response?.error?.status;
    if (typeof statusCode === 'number' && statusCode >= 500) {
      return 'ERR.GENERIC';
    }
    return 'ERR.GENERIC';
  }

  private createPaymentErrorModalData(errorCode: string): ErrorModalData {
    const errorConfigs: { [key: string]: any } = {
      'ERR.PAYMENT.CARD.INVALID': {
        title: '👉 Los datos de la tarjeta no son válidos. Revisa la información e inténtalo de nuevo.',
        subMessage: '',
        buttonText: 'Corregir datos',
        showSubMessage: true
      },
      'ERR.PAYMENT.DECLINED.DUPLICATE': {
        title: '👉 Parece que este pago ya fue procesado. Intenta con uno nuevo.',
        subMessage: '',
        buttonText: 'Hacer nuevo intento',
        showSubMessage: true
      },
      'ERR.PAYMENT.DECLINED': {
        title: '👉 El pago fue rechazado. Intenta de nuevo o usa otro método.',
        subMessage: '',
        buttonText: 'Volver a intentar',
        showSubMessage: true
      },
      'ERR.PAYMENT.DECLINED.BY.ISSUER': {
        title: '👉 El banco ha rechazado la operación. Contacta con tu entidad para más detalles.',
        subMessage: '',
        buttonText: 'Intentar con otra tarjeta',
        showSubMessage: true
      },
      'ERR.PAYMENT.DECLINED.INSUFFICIENT.FUNDS': {
        title: '👉 No tienes fondos suficientes para completar el pago.',
        subMessage: '',
        buttonText: 'Usar otro método de pago',
        showSubMessage: true
      },
      'ERR.PAYMENT.DECLINED.FRAUD': {
        title: '👉 La tarjeta fue reportada por actividad sospechosa. Contacta con tu banco.',
        subMessage: '',
        buttonText: 'Intentar con otra tarjeta',
        showSubMessage: true
      },
      'ERR.PAYMENT.DECLINED.STOLEN.CARD': {
        title: '👉 La tarjeta fue reportada como robada. No es posible procesar el pago.',
        subMessage: '',
        buttonText: 'Usar otra tarjeta',
        showSubMessage: true
      },
      'ERR.VAL.INV': {
        title: 'Cotización Ya Pagada',
        subMessage: 'Esta cotización ya ha sido pagada. No se puede procesar un pago duplicado.',
        buttonText: 'Entendido',
        showSubMessage: true
      },
      'ERR.GENERIC': {
        title: 'Error de Pago',
        subMessage: 'Ha ocurrido un error durante el procesamiento del pago. Por favor, intente nuevamente.',
        buttonText: 'Reintentar',
        showSubMessage: true
      }
    };

    const config = errorConfigs[errorCode] || errorConfigs['ERR.GENERIC'];

    return {
      errorCode: errorCode,
      title: config.title,
      subMessage: config.subMessage,
      buttonText: config.buttonText,
      showSubMessage: config.showSubMessage
    };
  }

  onPaymentErrorActionClick(errorCode: string): void {
    // Hide the error modal
    const errorModal = document.getElementById('paymentErrorModal');
    if (errorModal) {
      const modalInstance = (window as any).bootstrap?.Modal?.getInstance(errorModal);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
    
    // Clear the error data
    this.currentErrorData = null;
    
    // Reset payment status to allow retry
    if (errorCode.includes('RETRY') || errorCode === 'ERR.PAYMENT.CARD.INVALID' || errorCode === 'ERR.PAYMENT.DECLINED' || errorCode === 'ERR.PAYMENT.DECLINED.INSUFFICIENT.FUNDS') {
      this.paymentStatus = 0;
      this.paymentErrorMessage = '';
    }
  }

/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Sends a quote via email to the recipients specified in the form.
 * 
 * This function first checks if an email is already being sent by
 * verifying the `isBusy` status. If not, it sets `isBusy` to true
 * and changes `emailSendingStatus` to 1 to indicate the process has started.
 * It then creates a `SendQuoteByEmailModel` request from the current
 * quote model and the optional recipient emails provided in the form.
 * 
 * The email sending process is initiated through the `quoteService`.
 * Upon success, it logs the result, sets `isBusy` to false, and updates
 * and keeps `emailSendingStatus` at 3 to indicate failure.
 */


/*******  131f2238-4820-4ee3-a32f-23ea4ce1da4a  *******/
  sendEmail(): void {
    if (this.isBusy) {
      return;
    }
    this.isBusy = true;
    this.emailSendingStatus = 1;


    const json: string = JSON.stringify(this.quoteService.quoteModel);
    let quoteModel: GetQuoteResponseModel = JSON.parse(json);

    const request = new SendQuoteByEmailModel({
      recipientEmails: this.sendQuoteByEmailForm.controls.optionalRecipients.value,
      quoteModel: quoteModel
    });

    const self = this;
    self.quoteService.sendQuoteByEmail$(request)
      .subscribe(success => {
        self.isBusy = false;
        self.emailSendingStatus = success
          ? 2
          : 3;
      }, error => {
        console.error('Error sending quote by email');
      });
  }
}
